<script setup lang="ts">
import { createError, useError } from '#app/composables/error';
import ErrorScreen from './ErrorScreen.vue';

const error = useError();
</script>

<template>
	<ErrorScreen :error="error ?? createError({ status: 404 })" />
</template>
